<template>
  <div>
    <product-page-wrapper type="ebook" />
  </div>
</template>

<script>
import ProductPageWrapper from "@/components/products/ProductPageWrapper.vue";

export default {
  components: {
    ProductPageWrapper,
  },
};
</script>
